import React, { FC, useState } from 'react';

import { SearchViewModel } from '@api/index';
import { BookerSearchViewModel } from '@components/views/landing/components/booker/common/BookerSearchDrawer';
import ResponsiveListingSearchLocation from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchLocation';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { HotelTypes } from '@domain/hotel/hotelAutoComplate';

interface IMobileHotelSelection {
  label: string;
  onChange?: (data: SearchViewModel) => void;
  history?: BookerSearchViewModel[];
  clearPastHotelSearch?: () => void;
  removePastHotelSearch?: (item: BookerSearchViewModel) => void;
  isLocationError: boolean;
  setIsLocationError: (value: boolean) => void;
  activeLocation?: HotelTypes;
}

const MobileHotelSelection: FC<IMobileHotelSelection> = ({
  activeLocation,
  onChange,
  history,
  clearPastHotelSearch,
  removePastHotelSearch,
  isLocationError,
  setIsLocationError,
}) => {
  const [isShowSearchListingLocation, setIsSHowSearchListingLocation] =
    useState(false);
  const [inputLocation, setInputLocation] = useState<string>(
    activeLocation?.text || ''
  );
  const [openAutoCompleteResult, setOpenAutoCompleteResult] =
    useState<boolean>(false);

  /**
   * Handling Clicking on the apply button
   */
  const applySearchLocationHandler = (
    currentSelectedLocation: BookerSearchViewModel
  ) => {
    if (!currentSelectedLocation?.text) {
      setIsLocationError(true);
      return;
    }

    setInputLocation(currentSelectedLocation?.text || '');
    setIsSHowSearchListingLocation(false);
    onChange?.(currentSelectedLocation as SearchViewModel);
    isLocationError && setIsLocationError(false);
  };

  /**
   * Handling Clicking on close location search icon
   */
  const handleCloseLocationSearch = () => {
    setIsSHowSearchListingLocation(false);
    setOpenAutoCompleteResult(false);
  };

  /**
   * Handling Clicking on the location search icon
   */
  const handleOpenLocationSearch = () => {
    setIsSHowSearchListingLocation(true);
  };

  return (
    <LocationAnimationErrorBox hasError={isLocationError || false}>
      <ResponsiveListingSearchLocation
        type='hotel'
        showLocationModal={handleOpenLocationSearch}
        width='100%'
        height='100%'
        placement='top'
        title='Otel / Konum Arama'
        open={isShowSearchListingLocation}
        locationInput={inputLocation}
        locationInputError={isLocationError}
        handleUpdateButton={applySearchLocationHandler}
        handleCloseLocationSearch={handleCloseLocationSearch}
        openAutoCompleteResultModal={openAutoCompleteResult}
        setOpenAutoCompleteResultModal={setOpenAutoCompleteResult}
        pastSearchesData={history}
        onRemoveItem={removePastHotelSearch}
        onClearClick={clearPastHotelSearch}
      />
    </LocationAnimationErrorBox>
  );
};

export default MobileHotelSelection;
